export default __webpack_public_path__ + "static/media/BranchManagement.613703cf.svg";